import { useMutation } from 'react-query';
import { INIT_UI_LANGUAGE } from 'constants/languages';
import apiCubic from 'config/api-cubic';

export const KEY = 'USE_DEACTIVATE_PACKAGE';

const call = async ({ contractCode, pkg }) => {
  const data = await apiCubic.post({
    endpoint: apiCubic.endpoints.deactivateSubscription,
    data: { contractCode, subTmCode: pkg.id, language: INIT_UI_LANGUAGE },
  });

  if (data.error) {
    const error = new Error(data.error.message);
    error.code = data.error.code;
    throw error;
  }

  return data;
};

export const useDeactivatePackage = (options = {}) => {
  return useMutation(call, { mutationKey: KEY, ...options });
};

export default useDeactivatePackage;
